import { Suspense } from 'react';
import { DialogTrigger } from 'react-aria-components';
import { msg } from '@gonfalon/messages/msg';
import { IconButton, Popover } from '@launchpad-ui/components';

import { trackEnvironmentEvent } from '../analytics';
import { type SelectedEnvironment } from '../types';
import { useEventLocation } from '../utils/getEventLocation';

import { EnvironmentFallback } from './EnvironmentFallback';
import { SelectEnvironmentDialog } from './SelectEnvironmentDialog';

export function ReplaceEnvironmentMenuTrigger({
  className,
  projectKey,
  environmentName,
  excludedIds,
  onSelect,
}: {
  className?: string;
  projectKey: string;
  environmentName: string;
  excludedIds: Set<string>;
  onSelect: (environment: SelectedEnvironment) => void;
}) {
  const location = useEventLocation();

  return (
    <DialogTrigger
      onOpenChange={(open) => {
        if (open) {
          trackEnvironmentEvent('Swap Environment Clicked', { location });
        }
      }}
    >
      <IconButton
        className={className}
        aria-label={msg('chrome.environmentSelector.swapNamed', { environmentName })}
        variant="minimal"
        size="small"
        icon="swap-horiz"
      />
      <Popover>
        <Suspense fallback={<EnvironmentFallback />}>
          <SelectEnvironmentDialog
            projectKey={projectKey}
            excludedIds={excludedIds}
            onSelect={(env) => {
              trackEnvironmentEvent('Swap Environment Selected', { environmentKey: env.key, location });
              onSelect(env);
            }}
          />
        </Suspense>
      </Popover>
    </DialogTrigger>
  );
}
